/**
 * MarkdownRenderer
 * Renderiza conteúdo Markdown como HTML formatado.
 * Suporta tabelas (GFM), listas, headings, bold, italic, code, blockquote.
 */

import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownRendererProps {
  content: string;
  className?: string;
}

const STYLES = `
  .prainte-md h1, .prainte-md h2, .prainte-md h3, .prainte-md h4 {
    font-weight: 700 !important; margin-top: 1.4em !important; margin-bottom: 0.5em !important; color: #111827 !important;
  }
  .prainte-md h1 { font-size: 1.4rem !important; }
  .prainte-md h2 { font-size: 1.2rem !important; }
  .prainte-md h3 { font-size: 1.05rem !important; }
  .prainte-md p { margin-bottom: 0.9em !important; }
  .prainte-md ul, .prainte-md ol { padding-left: 1.5em !important; margin-bottom: 0.9em !important; list-style: revert !important; }
  .prainte-md li { margin-bottom: 0.3em !important; display: list-item !important; }
  .prainte-md strong { font-weight: 700 !important; }
  .prainte-md em { font-style: italic !important; }
  .prainte-md blockquote {
    border-left: 4px solid #d1d5db !important; padding-left: 1em !important; color: #6b7280 !important; margin: 1em 0 !important;
  }
  .prainte-md code {
    background: #f3f4f6 !important; padding: 0.15em 0.4em !important; border-radius: 4px !important;
    font-size: 0.88em !important; font-family: monospace !important;
  }
  .prainte-md pre { background: #f3f4f6 !important; padding: 1em !important; border-radius: 8px !important; overflow-x: auto !important; margin-bottom: 1em !important; }
  .prainte-md pre code { background: none !important; padding: 0 !important; }
  .prainte-md table { width: 100% !important; border-collapse: collapse !important; margin-bottom: 1em !important; font-size: 0.9em !important; }
  .prainte-md th { background: #f9fafb !important; font-weight: 700 !important; text-align: left !important; padding: 8px 12px !important; border: 1px solid #d1d5db !important; }
  .prainte-md td { padding: 8px 12px !important; border: 1px solid #d1d5db !important; }
  .prainte-md tr:nth-child(even) td { background: #f9fafb !important; }
  .prainte-md hr { border: none !important; border-top: 1px solid #e5e7eb !important; margin: 1.5em 0 !important; }
`;

let stylesInjected = false;

export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content, className }) => {
  // Injeta os estilos globalmente uma única vez
  React.useEffect(() => {
    if (stylesInjected) return;
    const el = document.createElement('style');
    el.setAttribute('data-prainte-md', '');
    el.textContent = STYLES;
    document.head.appendChild(el);
    stylesInjected = true;
  }, []);

  return (
    <div
      className={`prainte-md${className ? ' ' + className : ''}`}
      style={{ fontSize: '0.95rem', lineHeight: '1.75', color: '#1f2937' }}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
